import { NegotiationDetail, RfqType } from 'api'
import React from 'react'
import { RepositoryActions } from 'store/repository'
import { isNotNil } from 'utils/predicate'
import { TypedCellRendererParams } from 'view/components/datagrid'
import { Checkbox } from 'view/components/inputs'
import { CheckboxContainer, Container } from './NegotiationActionRendererStyles'
import { getChangeHandler } from './NegotiationActionRendererChangeHandlerStrategy'
import { getDescendantComponentProps } from './NegotiationActionRendererUtils'
import { connect } from 'react-redux'
import { GlobalState } from 'store'
import {
  createSelectedNegotiationDetailLeg,
  createSelectedNegotiationDetailSummary
} from 'selectors/negotiations/negotiationCounterpartySelectors'
import { isNil } from 'lodash'
import { IndicativeContainer } from 'view/shared/datagrid'
import { getNegotiatedValue } from '../../shared/utils'
import { iconSet } from 'view/components/icons'

export interface NegotiationCheckboxRendererProps extends TypedCellRendererParams<NegotiationDetail> {
  onUpdateMeta: typeof RepositoryActions.updateMeta
  selectedNegotiationDetail?: NegotiationDetail
  selectedNegotiationDetailSummary?: NegotiationDetail
}

const mapStateToProps = (state: GlobalState, props: NegotiationCheckboxRendererProps) => {
  const negotiationDetail = props.data
  return negotiationDetail
    ? {
        selectedNegotiationDetail: createSelectedNegotiationDetailLeg(negotiationDetail)(state),
        selectedNegotiationDetailSummary: createSelectedNegotiationDetailSummary(negotiationDetail)(state)
      }
    : {}
}

const mapDispatchToProps = {
  onUpdateMeta: RepositoryActions.updateMeta
}

export const NegotiationCheckboxRendererComponent: React.FC<NegotiationCheckboxRendererProps> = props => {
  const { onUpdateMeta, node, selectedNegotiationDetail, selectedNegotiationDetailSummary } = props
  const { checkboxProps } = getDescendantComponentProps(props)

  if (isNil(node?.data)) {
    return null
  }

  const negotiationDetail = node.data

  const isChecked = () => {
    return (
      isNotNil(negotiationDetail) &&
      (selectedNegotiationDetail?.negotiation.negotiationId === negotiationDetail?.negotiation.negotiationId ||
        selectedNegotiationDetailSummary?.negotiation.negotiationId === negotiationDetail?.negotiation.negotiationId)
    )
  }

  const handleChange = getChangeHandler({
    isGroup: node.group || false,
    currentNegotiationDetail: node.data,
    selectedNegotiationDetail,
    selectedNegotiationDetailSummary,
    onUpdateMeta
  })

  return (
    <Container>
      <CheckboxContainer>
        <Checkbox isChecked={isChecked()} onUpdate={handleChange} {...checkboxProps} />
      </CheckboxContainer>
      {getNegotiatedValue(negotiationDetail.negotiation.rfqType) === RfqType.INDICATIVE && (
        <IndicativeContainer>{iconSet.indicativeIcon}</IndicativeContainer>
      )}
    </Container>
  )
}

export const NegotiationCheckboxRenderer = connect(mapStateToProps, mapDispatchToProps)(NegotiationCheckboxRendererComponent)
